/* Bannière de consentement — habillage de la bannière native de Shopify.

   Il n'y a qu'un seul système de consentement sur le site : celui de Shopify
   (Paramètres → Confidentialité des clients), généré par storefront-banner.js
   et injecté dans <body> sous #shopify-pc__banner.

   Ce fichier ne crée AUCUNE bannière et ne touche à AUCUN cookie. Il fait trois
   choses :
     1. il réécrit les libellés de la bannière existante, que Shopify n'expose
        pas au thème, sans toucher aux boutons eux-mêmes ni à leurs gestionnaires ;
     1 bis. il mesure la place que la bannière occupe en bas de l'écran, pour que
        le tiroir panier ne passe pas dessous (17/10/2026) ;
     2. il branche le lien « Gérer mes cookies » du pied de page sur l'API
        officielle privacyBanner.showPreferences().

   Les trois boutons restent ceux de Shopify : même identifiant, même
   comportement, même appel à l'API Customer Privacy. Le refus reste accessible
   en un clic depuis le premier écran.

   Le texte annonce la mesure d'audience ET la publicité, parce que les deux
   catégories sont réellement concernées : accepter déclenche le pixel
   Pinterest. Annoncer seulement la « mesure » serait inexact.
*/
(function () {
  'use strict';

  var TEXTES = {
    titre: 'Une meilleure expérience sur Tiloa',
    corps: 'Nous utilisons des cookies pour mesurer l’audience de la boutique et vous proposer des publicités adaptées.',
    accepter: 'Accepter et continuer',
    refuser: 'Continuer sans accepter',
    preferences: 'Gérer mes préférences',
  };

  /* ---------- 1. Libellés de la bannière ---------- */

  function habiller(dialog) {
    if (!dialog || dialog.dataset.tiloaHabille === '1') return;

    var titre = dialog.querySelector('#shopify-pc__banner__body-title');
    if (titre) titre.textContent = TEXTES.titre;

    // On garde le lien vers la politique de confidentialité tel que Shopify
    // l'a produit : c'est une mention obligatoire, et son URL vient du thème.
    var p = dialog.querySelector('.shopify-pc__banner__body p');
    if (p) {
      var lien = p.querySelector('a');
      p.textContent = TEXTES.corps + ' ';
      if (lien) p.appendChild(lien);
    }

    var libelle = function (sel, texte) {
      var b = dialog.querySelector(sel);
      if (!b) return;
      // Le bouton « préférences » enveloppe son texte dans un <span>.
      var cible = b.querySelector('span') || b;
      cible.textContent = texte;
    };
    libelle('#shopify-pc__banner__btn-accept', TEXTES.accepter);
    libelle('#shopify-pc__banner__btn-decline', TEXTES.refuser);
    libelle('#shopify-pc__banner__btn-manage-prefs', TEXTES.preferences);

    dialog.dataset.tiloaHabille = '1';
    document.documentElement.classList.add('tiloa-banniere-prete');
  }

  function chercher() {
    habiller(document.querySelector('.shopify-pc__banner__dialog'));
  }

  chercher();
  // La bannière est injectée après le chargement, et Shopify peut la
  // reconstruire (réouverture depuis les préférences). L'observateur reste
  // actif : le marqueur data- évite de retravailler un nœud déjà habillé.
  if (document.body) {
    new MutationObserver(chercher).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 1 bis. Place occupée par la bannière (tiroir panier) ----------
     Tant que la bannière est affichée, <html> porte la classe tp-banniere-ouverte et la variable
     --tp-banniere-h : hauteur occupée depuis le bas de l'écran (écart et safe-area iOS compris, puisque
     mesurée depuis le haut de la bannière), et tp-banniere-serree s'il reste moins de 26rem au-dessus d'elle là
     où elle peut couvrir le tiroir (même condition que assets/tiloa-offre-panier.css).
     assets/tiloa-offre-panier.css s'en sert pour arrêter le tiroir au-dessus de la bannière, au lieu de laisser
     son bouton de paiement dessous.
     Tout est retiré dès que la bannière est masquée (choix fait) : aucune marge résiduelle.
     Ne touche ni à la bannière, ni à ses boutons, ni au consentement. */
  (function zoneBanniere() {
    var racine = document.documentElement;
    var suivie = null;
    var raf = 0;
    var derniere = -1;
    var ro = window.ResizeObserver ? new ResizeObserver(planifier) : null;
    var couvre = window.matchMedia ? window.matchMedia('(max-width: 749.98px), (max-width: 839.98px) and (min-height: 600px)') : null;
    var obsBanniere = new MutationObserver(planifier);

    function planifier() { if (!raf) raf = window.requestAnimationFrame(maj); }

    function maj() {
      raf = 0;
      var h = 0;
      var cs = suivie && suivie.isConnected ? getComputedStyle(suivie) : null;
      if (cs && cs.display !== 'none') {
        var r = suivie.getBoundingClientRect();
        // Bannière fixée en bas : écart du bas (safe-area comprise) + hauteur, sans dépendre de innerHeight
        // (qui suit la zone zoomée pendant un pincement sur iOS).
        var bas = parseFloat(cs.bottom);
        if (r.height > 0) h = Math.ceil(cs.position === 'fixed' && isFinite(bas) ? bas + r.height : window.innerHeight - r.top);
        if (h < 0) h = 0;
      }
      // Place serrée (téléphone en paysage) : seuil en rem pour suivre la taille du texte.
      // 26rem depuis le 17/10 (b) (32rem avant) : le bloc collé du tiroir ne fait plus que ~96 px (total + bouton),
      // au lieu de ~186 ; au-dessus de 260 px, en-tête + une ligne entière + bloc collé tiennent encore.
      var seuil = 26 * (parseFloat(getComputedStyle(racine).fontSize) || 10);
      var serree = h > 0 && (!couvre || couvre.matches) && window.innerHeight - h < seuil;
      if (h === derniere && serree === racine.classList.contains('tp-banniere-serree')) return;
      derniere = h;
      if (h > 0) {
        racine.style.setProperty('--tp-banniere-h', h + 'px');
        racine.classList.add('tp-banniere-ouverte');
      } else {
        racine.style.removeProperty('--tp-banniere-h');
        racine.classList.remove('tp-banniere-ouverte');
      }
      racine.classList.toggle('tp-banniere-serree', serree);
    }

    // Shopify affiche puis masque la bannière par son attribut style, et peut la recréer.
    // L'observateur de <body> ne fait qu'une recherche (aucune lecture de mise en page) :
    // les minuteurs de la page le déclenchent chaque seconde.
    function suivre() {
      var d = document.querySelector('.shopify-pc__banner__dialog');
      if (d === suivie) return;
      obsBanniere.disconnect();
      if (ro) ro.disconnect();
      suivie = d;
      if (d) {
        obsBanniere.observe(d, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        if (ro) ro.observe(d);
      }
      planifier();
    }

    suivre();
    if (document.body) new MutationObserver(suivre).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', planifier);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', planifier);
  })();

  /* ---------- 2. Lien « Gérer mes cookies » du pied de page ---------- */

  var boutons = document.querySelectorAll('[data-tiloa-cookie-prefs]');
  if (!boutons.length) return;

  function disponible() {
    return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
  }

  function afficher() {
    for (var i = 0; i < boutons.length; i++) boutons[i].hidden = false;
    // Shopify ajoute de son côté un lien « Préférences en matière de cookies »
    // dans la liste des politiques. Il ouvre exactement la même fenêtre : on
    // masque le doublon, mais seulement une fois notre bouton opérationnel,
    // pour ne jamais se retrouver sans aucun accès aux préférences.
    document.documentElement.classList.add('tiloa-cookies-pret');
  }

  // storefront-banner.js est chargé en différé : on laisse quelques secondes.
  var essais = 0;
  (function attendre() {
    if (disponible()) { afficher(); return; }
    if (++essais > 40) return;
    setTimeout(attendre, 250);
  })();

  for (var i = 0; i < boutons.length; i++) {
    boutons[i].addEventListener('click', function (e) {
      e.preventDefault();
      if (disponible()) window.privacyBanner.showPreferences();
    });
  }
})();
